<template>
  <EditItemDialogButton ref="editDialog" @click="click" v-bind="$attrs">
    <template v-slot:dialog-button-text>
      <slot name="dialog-button-text"> </slot>
    </template>
    <template v-slot:dialog-form>
      <EditDeskSlotForm :con="controller" :editedItem="deskSlot" @closed="close" />
    </template>
  </EditItemDialogButton>
</template>

<script>
import EditItemDialogButton from "@/components/components-salles/admin/crud/EditItemDialogButton";
import EditDeskSlotForm from "./EditDeskSlotForm.vue";
import CrudDeskSlotsTable from "@/models/crud/CrudDesksTable";
import { mapActions } from "vuex";

export default {
  name: "EditDeskSlotDialogButton",
  components: {
    EditItemDialogButton,
    EditDeskSlotForm,
  },
  props: {
    desk: null,
    deskSlot: null,
  },
  computed: {
    controller() {
      return {
        ...CrudDeskSlotsTable,
        crud: {
          create: (item) => {
            item.desk = this.desk;
            return this.addDeskSlot(item);
          },          
          update: (item) => {
            return this.editDeskSlot(item);
          },
        },
      };
    },
  },  
  methods: {
    ...mapActions("deskSlotModule", ["addDeskSlot", "editDeskSlot"]),

    close() {
      this.$refs.editDialog.close();
      this.$emit("closed");
    },
    click() {
      this.$emit("click");
    },
  },
};
</script>
